// extracted by mini-css-extract-plugin
export var sliderRange = "_rb-2";
export var sliderRoot = "_rb-0";
export var sliderThumb = "_rb-3";
export var sliderTrack = "_rb-1";